import { useTypedSelector } from 'lib/centralStore';
import { selectRedirectConfig } from 'features/configuration/selectors';
import { isCrawler, isMatch, isMobileBrowser } from 'utility/functions';
import { AppFragment } from 'enums/path-fragment';

const ALLOWED_VERTICALS: Array<string> = [
  AppFragment.Live,
  AppFragment.Sport,
  AppFragment.Ippica,
  AppFragment.Virtuali,
];

export const RedirectAppSport = (label, user) => {
  const isMobile = isMobileBrowser();
  const is_Crawler = isCrawler();
  // distinguish redirect by path instead of globally
  const flags = useTypedSelector(selectRedirectConfig);
  const vertical = label.toString().toLowerCase() === 'virtual' ? 'virtuali' : label.toString().toLowerCase();

  if (!isMatch(process.env.NEXT_PUBLIC_MOBILE_REDIRECT_URL, '^http')) return false;
  if (!isMobile) return false;
  if (is_Crawler) return false;
  if (!ALLOWED_VERTICALS.includes(vertical)) return false;
  if (!flags[vertical]) return false;

  const params = new URLSearchParams();
  switch (vertical) {
    case AppFragment.Virtuali:
      params.set('redirect', 'virtual');
      break;
    case AppFragment.Sport:
      params.set('redirect', 'home');
      break;
    default:
      params.set('redirect', vertical);
  }

  const { token, cardNumber } = user ?? {};
  if (token) params.set('token', token);
  if (cardNumber) params.set('carta', cardNumber);

  const url = `${process.env.NEXT_PUBLIC_MOBILE_REDIRECT_URL}?${params.toString()}`;
  return url;
};
